import { render } from "./TemplateListComponent.vue?vue&type=template&id=0bf1f2c6&scoped=true&ts=true"
import script from "./TemplateListComponent.vue?vue&type=script&lang=ts"
export * from "./TemplateListComponent.vue?vue&type=script&lang=ts"

import "./TemplateListComponent.vue?vue&type=style&index=0&id=0bf1f2c6&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf1f2c6"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpinnerFacebook});
